import type { Todo } from "../../domain/entities.ts";

export interface SearchContext {
  categoryName: string;
  spaceName: string;
  today: string;
}

export function freeTextQuery(query: string): string {
  return query.trim().split(/\s+/).filter(token => !/^(tag|priority|due|space):/i.test(token)).join(" ");
}

export function matchesTaskSearch(todo: Todo, query: string, context: SearchContext): boolean {
  const tokens = query.trim().split(/\s+/).filter(Boolean);
  const textTerms: string[] = [];
  for (const token of tokens) {
    const match = /^(tag|priority|due|space):(.*)$/i.exec(token);
    if (!match) { textTerms.push(token.toLocaleLowerCase()); continue; }
    const value = match[2].toLocaleLowerCase();
    if (match[1].toLowerCase() === "tag" && !Object.entries(todo.tags || {}).some(([tag, active]) => active && tag.toLocaleLowerCase() === value)) return false;
    if (match[1].toLowerCase() === "priority" && todo.priority !== value) return false;
    if (match[1].toLowerCase() === "space" && !context.spaceName.toLocaleLowerCase().includes(value)) return false;
    if (match[1].toLowerCase() === "due") {
      if (value === "today" && todo.dueDate !== context.today) return false;
      if (value === "overdue" && (!todo.dueDate || todo.dueDate >= context.today || todo.completed)) return false;
      if (value === "none" && todo.dueDate) return false;
      if (!["today", "overdue", "none"].includes(value) && todo.dueDate !== value) return false;
    }
  }
  const searchable = `${todo.title} ${todo.description} ${(todo.subtasks || []).map(item => `${item.title} ${item.note || ""}`).join(" ")} ${Object.keys(todo.tags || {}).join(" ")} ${context.categoryName} ${Object.values(todo.customFields || {}).filter(value => value != null).join(" ")}`.toLocaleLowerCase();
  return textTerms.every(term => searchable.includes(term));
}

export function rememberSearch(recent: string[], query: string, limit = 6): string[] {
  const value = query.trim();
  return value ? [value, ...recent.filter(item => item !== value)].slice(0, limit) : recent;
}
